import React, { Fragment } from 'react';
import { Form, Button, Header, Card, Divider } from 'semantic-ui-react';
import scrollToError from '../../../utils/scrollToError';
import AirlineAnswer from './AirlineAnswer';
import Delay from './Delay';
import Flights from './Flights';
import Passengers from './Passengers';
import LawyerFormField from '../../FormFields/LawyerFormField';
import _ from 'lodash';
import Litigation from './Litigation';
class ClaimForm extends React.Component {
  componentDidUpdate(prevProps) {
    const { isSubmitting, isValid, errors } = this.props;
    if (prevProps.isSubmitting && !isSubmitting && !isValid)
      scrollToError(errors);
  }
  render = () => {
    const {
      loading,
      onChange,
      onSubmit,
      values,
      values: { passengerTicketId },
      onTimeChange,
      claim,
      onBlur,
      onCancel,
      errors,
      touched,
      onClaimUpdated,
      hideLoading,
      showLoading,
      setFieldValue
    } = this.props;
    const { crmState, id } = claim || '';
    const flights = _.get(values, 'flights', []);
    const passengers = _.get(values, 'passengers', []);
    const commonProps = {
      onClaimUpdated,
      hideLoading,
      showLoading,
      setFieldValue,
      onBlur,
      errors,
      touched,
      passengerTicketId
    };
    const flightsData = {
      flights,
      flightId: values.flightId || '',
      ...commonProps
    };
    const passengersData = {
      passengers,
      id,
      onChange,
      ...commonProps
    };
    return (
      <Form loading={loading}>
        <Header>Edit claim</Header>
        <Form.TextArea
          value={values.comments}
          name={'comments'}
          onChange={onChange}
          rows={2}
          label="Comment"
        />
        {/^c|^b/.test(crmState) && (
          <Card fluid>
            <Card.Content>
              <Header as="h4">Litigation</Header>
              {/^c|^b/.test(crmState) && (
                <AirlineAnswer
                  onChange={onChange}
                  values={values}
                  claim={claim}
                  onTimeChange={onTimeChange}
                />
              )}
              {crmState.startsWith('c') && (
                <Fragment>
                  <Divider />
                  <Divider hidden />
                  <Litigation
                    onTimeChange={onTimeChange}
                    onChange={onChange}
                    values={values}
                    crmState={crmState}
                  />
                </Fragment>
              )}
              {crmState.startsWith('c') && (
                <LawyerFormField
                  fluid
                  selection
                  search
                  displayInline
                  lawyer={values.lawyer}
                  litigationCountry={values.litigationCountry}
                  onChange={onChange}
                  crmState={crmState}
                />
              )}
            </Card.Content>
          </Card>
        )}

        <Delay onChange={onChange} values={values} />
        <Header as="h4">Trip information</Header>
        <Flights {...flightsData} />
        <Header as="h4">Passengers</Header>
        <Passengers {...passengersData} />
        <Button primary onClick={onSubmit} content="Save" />
        <Button basic onClick={onCancel} content="Cancel" />
      </Form>
    );
  };
}
export default ClaimForm;



// WEBPACK FOOTER //
// ./src/component/ClaimForm/Form/index.js